var __extends =
  (this && this.__extends) ||
  (function () {
    var extendStatics = function (d, b) {
      extendStatics =
        Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array &&
          function (d, b) {
            d.__proto__ = b
          }) ||
        function (d, b) {
          for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]
        }
      return extendStatics(d, b)
    }
    return function (d, b) {
      extendStatics(d, b)
      function __() {
        this.constructor = d
      }
      d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __())
    }
  })()
var __assign =
  (this && this.__assign) ||
  function () {
    __assign =
      Object.assign ||
      function (t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i]
          for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p]
        }
        return t
      }
    return __assign.apply(this, arguments)
  }
var __rest =
  (this && this.__rest) ||
  function (s, e) {
    var t = {}
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p]
    if (s != null && typeof Object.getOwnPropertySymbols === 'function')
      for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]]
      }
    return t
  }
/* eslint-disable jsx-a11y/anchor-is-valid */
import classNames from 'classnames'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import PerfectScrollbar from 'react-perfect-scrollbar'
import 'react-perfect-scrollbar/dist/css/styles.css'
import { NavLink } from 'react-router-dom'
import { Badge, Nav, NavItem, NavLink as RsNavLink } from 'reactstrap'
import { ODIcon } from '../../../../icons'
import { ODAppSidebarNavSeparator } from './ODAppSidebarNavSeparator'
var propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  navConfig: PropTypes.any,
  navFunc: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  isOpen: PropTypes.bool,
  staticContext: PropTypes.any,
  tag: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  iconSpanStyle: PropTypes.object,
}
var defaultProps = {
  tag: 'nav',
  navConfig: {
    items: [
      {
        name: 'Dashboard',
        url: '/dashboard',
        icon: 'icon-speedometer',
        badge: { variant: 'info', text: 'NEW' },
      },
    ],
  },
  isOpen: false,
}
var ODAppSidebarNav = /** @class */ (function (_super) {
  __extends(ODAppSidebarNav, _super)
  function ODAppSidebarNav(props) {
    var _this = _super.call(this, props) || this
    _this.handleClick = _this.handleClick.bind(_this)
    _this.activeRoute = _this.activeRoute.bind(_this)
    _this.hideMobile = _this.hideMobile.bind(_this)
    return _this
  }
  ODAppSidebarNav.prototype.handleClick = function (e) {
    e.preventDefault()
    e.currentTarget.parentElement.classList.toggle('open')
  }
  ODAppSidebarNav.prototype.activeRoute = function (routeName, props) {
    return props.location.pathname.indexOf(routeName) > -1 ? 'nav-item nav-dropdown open' : 'nav-item nav-dropdown'
  }
  ODAppSidebarNav.prototype.hideMobile = function () {
    if (document.body.classList.contains('sidebar-show')) {
      document.body.classList.toggle('sidebar-show')
    }
  }
  // nav list
  ODAppSidebarNav.prototype.navList = function (items) {
    var _this = this
    return items.map(function (item, index) {
      return _this.navType(item, index)
    })
  }
  // nav type
  ODAppSidebarNav.prototype.navType = function (item, idx) {
    return item.title
      ? this.navTitle(item, idx)
      : item.divider
      ? this.navDivider(item, idx)
      : item.label
      ? this.navLabel(item, idx)
      : item.children
      ? this.navDropdown(item, idx)
      : this.navItem(item, idx)
  }
  // nav list section title
  ODAppSidebarNav.prototype.navTitle = function (title, key) {
    var classes = classNames('nav-title', title.class)
    return React.createElement('li', { key: key, className: classes }, this.navWrapper(title), ' ')
  }
  // simple wrapper for nav-title item
  ODAppSidebarNav.prototype.navWrapper = function (item) {
    return item.wrapper && item.wrapper.element
      ? React.createElement(item.wrapper.element, item.wrapper.attributes, item.name)
      : item.name
  }
  // nav list divider
  ODAppSidebarNav.prototype.navDivider = function (divider, key) {
    var classes = classNames('divider', divider.class)
    return React.createElement('li', { key: key, className: classes })
  }
  // nav label with nav link
  ODAppSidebarNav.prototype.navLabel = function (item, key) {
    var classes = {
      item: classNames('hidden-cn', item.class),
      link: classNames('nav-label', item.class ? item.class : ''),
      icon: classNames(
        'nav-icon',
        !item.icon ? 'fa fa-circle' : item.icon,
        item.label.variant ? 'text-' + item.label.variant : '',
        item.label.class ? item.label.class : ''
      ),
    }
    return this.navLink(item, key, classes)
  }
  // nav dropdown
  ODAppSidebarNav.prototype.navDropdown = function (item, key) {
    var classIcon = classNames('nav-icon', item.icon)
    var attributes = JSON.parse(JSON.stringify(item.attributes || {}))
    var classes = classNames('nav-link', 'nav-dropdown-toggle', item.class, attributes.class)
    delete attributes.class
    return React.createElement(
      'li',
      { key: key, className: this.activeRoute(item.url, this.props) },
      React.createElement(
        'a',
        __assign({ className: classes, href: '#', onClick: this.handleClick }, attributes),
        React.createElement('i', { className: classIcon }),
        item.name,
        this.navBadge(item.badge)
      ),
      React.createElement('ul', { className: 'nav-dropdown-items' }, this.navList(item.children))
    )
  }
  // nav item with nav link
  ODAppSidebarNav.prototype.navItem = function (item, key) {
    var classes = {
      item: classNames(item.class),
      link: classNames('nav-link', item.variant ? 'nav-link-' + item.variant : ''),
      icon: classNames('nav-icon', item.icon),
    }
    return this.navLink(item, key, classes)
  }
  // nav link
  ODAppSidebarNav.prototype.navLink = function (item, key, classes) {
    var url = item.url || ''
    var _a = item.iconSpanStyle,
      iconSpanStyle = _a === void 0 ? {} : _a,
      _b = item.iconStyle,
      iconStyle = _b === void 0 ? {} : _b,
      isSeparator = item.isSeparator
    if (isSeparator) {
      return React.createElement(ODAppSidebarNavSeparator, { key: key })
    }
    var itemIcon = React.createElement(
      'span',
      { style: iconSpanStyle, className: 'nav-icon' },
      React.createElement(ODIcon, { icon: item.icon, className: classes.icon, style: iconStyle })
    )
    var itemBadge = this.navBadge(item.badge)
    var attributes = item.attributes || {}
    return React.createElement(
      NavItem,
      { key: key, className: classes.item },
      attributes.disabled
        ? React.createElement(
            RsNavLink,
            __assign({ href: '', className: classes.link }, attributes),
            itemIcon,
            item.name,
            itemBadge
          )
        : this.isExternal(url)
        ? React.createElement(
            RsNavLink,
            __assign({ href: url, className: classes.link, active: true }, attributes),
            itemIcon,
            item.name,
            itemBadge
          )
        : React.createElement(
            NavLink,
            __assign(
              {
                to: url,
                exact: item.exact || false,
                className: classes.link,
                activeClassName: 'active',
                onClick: this.hideMobile,
              },
              attributes
            ),
            itemIcon,
            item.name,
            itemBadge
          )
    )
  }
  // badge addon to NavItem
  ODAppSidebarNav.prototype.navBadge = function (badge) {
    if (badge) {
      var classes = classNames(badge.class)
      return React.createElement(Badge, { className: classes, color: badge.variant }, badge.text)
    }
    return null
  }
  ODAppSidebarNav.prototype.isExternal = function (url) {
    var link = url ? url.substring(0, 4) : ''
    return link === 'http'
  }
  ODAppSidebarNav.prototype.render = function () {
    var _a = this.props,
      className = _a.className,
      children = _a.children,
      navConfig = _a.navConfig,
      attributes = __rest(_a, ['className', 'children', 'navConfig'])
    delete attributes.isOpen
    delete attributes.staticContext
    delete attributes.Tag
    var navClasses = classNames(className, 'sidebar-nav')
    // ToDo: find better rtl fix
    var isRtl = getComputedStyle(document.documentElement).direction === 'rtl'
    // sidebar-nav root
    return React.createElement(
      PerfectScrollbar,
      __assign({ className: navClasses }, attributes, { options: { suppressScrollX: !isRtl } }),
      React.createElement(Nav, null, children || this.navList(navConfig.items))
    )
  }
  return ODAppSidebarNav
})(Component)
export { ODAppSidebarNav }
ODAppSidebarNav.propTypes = propTypes
ODAppSidebarNav.defaultProps = defaultProps
//# sourceMappingURL=ODAppSidebarNav.js.map
